import { useMutation } from "@tanstack/react-query";

import { queryClient } from "../../../config/react-query";
import { grappageLine } from "./actions";

export function useGrappageLine(folderId: string) {
    const mutation = useMutation({
        mutationFn: grappageLine,
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: ["folders", "grappage", folderId],
            });
        },
    });

    return mutation;
}
